import { isArray, isObject } from '@/utils/is'

export const useStorage = (type: 'sessionStorage' | 'localStorage' = 'sessionStorage') => {
  const setStorage = (key: string, value: any) => {
    window[type].setItem(key, isArray(value) || isObject(value) ? JSON.stringify(value) : value)
  }

  const getStorage = (key: string) => {
    const value = window[type].getItem(key)
    try {
      return JSON.parse(value || '')
    } catch (error) {
      return value
    }
  }

  const removeStorage = (key: string) => {
    window[type].removeItem(key)
  }

  const clear = () => {
    window[type].clear()
  }

  return {
    setStorage,
    getStorage,
    removeStorage,
    clear
  }
}

export const useLocalStorage = () => {
  const set = (key: string, value: any) => {
    window.localStorage.setItem(key, isArray(value) || isObject(value) ? JSON.stringify(value) : value)
  }

  const get = (key: string) => {
    const value = window.localStorage.getItem(key)
    try {
      return JSON.parse(value || '')
    } catch (error) {
      return value
    }
  }

  const remove = (key: string) => {
    window.localStorage.removeItem(key)
  }

  const clear = () => {
    window.localStorage.clear()
  }

  return {
    set,
    get,
    remove,
    clear
  }
}

export const useSessionStorage = () => {
  const set = (key: string, value: any) => {
    window.sessionStorage.setItem(key, isArray(value) || isObject(value) ? JSON.stringify(value) : value)
  }

  const get = (key: string) => {
    const value = window.sessionStorage.getItem(key)
    try {
      return JSON.parse(value || '')
    } catch (error) {
      return value
    }
  }

  const remove = (key: string) => {
    window.sessionStorage.removeItem(key)
  }

  const clear = () => {
    window.sessionStorage.clear()
  }

  return {
    set,
    get,
    remove,
    clear
  }
}
